// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ── View Notes / Medical Notes modal ───────────────────────────────── */
.view-notes-container {
  min-height: 460px;
  --vn-border: #e3e6eb;
  --vn-muted: #6b7280;
  --vn-strong: #1f2937;
  --vn-accent: #0f766e; /* teal-700 */
  --vn-accent-soft: #ccfbf1; /* teal-100 */
  --vn-head-bg: #f3f5f8;
  font-size: 13px;
  /* Keep the antd tab bar tight */
  /* ── Patient card ────────────────────────────────────────────────── */
  /* ── Shared column panel ─────────────────────────────────────────── */
  /* ── Medical history items ───────────────────────────────────────── */
  /* billing/charge rows are de-emphasised */
  /* ── Order notes list ────────────────────────────────────────────── */
  /* ── Note / document preview ─────────────────────────────────────── */
  /* ── HIS placeholder ─────────────────────────────────────────────── */
}
.view-notes-container .notes-header {
  font-size: 0.95rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: #334155;
}
.view-notes-container .ant-tabs-nav {
  margin-bottom: 8px;
}
.view-notes-container .ant-tabs-tab {
  padding: 6px 10px;
}
.view-notes-container .patient-card {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  column-gap: 18px;
  row-gap: 4px;
  padding: 8px 12px;
  background: linear-gradient(180deg, #fbfcfe 0%, #f5f7fa 100%);
  border: 1px solid var(--vn-border);
  border-radius: 8px;
}
.view-notes-container .pc-field {
  display: flex;
  flex-direction: column;
  min-width: 0;
  line-height: 1.25;
}
.view-notes-container .pc-label {
  font-size: 0.68rem;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--vn-muted);
}
.view-notes-container .pc-value {
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--vn-strong);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.view-notes-container .vn-columns {
  margin-top: 10px;
}
.view-notes-container .vn-panel {
  display: flex;
  flex-direction: column;
  height: 392px;
  border: 1px solid var(--vn-border);
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}
.view-notes-container .vn-panel-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  padding: 6px 10px;
  background: var(--vn-head-bg);
  border-bottom: 1px solid var(--vn-border);
  font-size: 0.74rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #475569;
}
.view-notes-container .vn-head-right {
  display: flex;
  align-items: center;
  gap: 6px;
}
.view-notes-container .vn-count {
  font-size: 0.66rem;
  font-weight: 700;
  color: #fff;
  background: var(--vn-accent);
  border-radius: 10px;
  padding: 0 6px;
  line-height: 16px;
}
.view-notes-container .mh-toggle {
  font-size: 0.64rem;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0;
  color: var(--vn-muted);
  border: 1px solid var(--vn-border);
  border-radius: 10px;
  padding: 1px 8px;
  cursor: pointer;
}
.view-notes-container .mh-toggle:hover {
  background: #eef0f3;
}
.view-notes-container .mh-toggle.active {
  color: var(--vn-accent);
  border-color: var(--vn-accent);
  background: var(--vn-accent-soft);
}
.view-notes-container .vn-panel-body {
  flex: 1;
  overflow-y: auto;
  padding: 6px;
}
.view-notes-container .vn-panel-body::-webkit-scrollbar {
  width: 6px;
}
.view-notes-container .vn-panel-body::-webkit-scrollbar-thumb {
  background-color: #d1d5db;
  border-radius: 4px;
}
.view-notes-container .vn-empty {
  color: #9aa1ab;
  font-style: italic;
  font-size: 0.8rem;
  padding: 8px;
  text-align: center;
}
.view-notes-container .mh-item {
  border: 1px solid var(--vn-border);
  border-left: 3px solid transparent;
  border-radius: 6px;
  padding: 5px 8px;
  margin-bottom: 5px;
  cursor: pointer;
  transition: background 0.12s ease, border-color 0.12s ease;
}
.view-notes-container .mh-item:hover {
  background: #f6f8fa;
}
.view-notes-container .mh-item .mh-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
}
.view-notes-container .mh-item .mh-date {
  font-size: 0.74rem;
  font-weight: 700;
  color: #374151;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.view-notes-container .mh-item .mh-chips {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}
.view-notes-container .mh-item .mh-mod {
  font-size: 0.62rem;
  font-weight: 700;
  color: var(--vn-accent);
  background: var(--vn-accent-soft);
  border-radius: 4px;
  padding: 1px 5px;
  letter-spacing: 0.02em;
}
.view-notes-container .mh-item .mh-nc {
  font-size: 0.62rem;
  font-weight: 700;
  color: #fff;
  background: #8b5cf6;
  border-radius: 9px;
  min-width: 16px;
  height: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
}
.view-notes-container .mh-item .mh-reportdate {
  color: var(--vn-muted);
  font-weight: 600;
}
.view-notes-container .mh-item .mh-view {
  display: inline-flex;
  align-items: center;
  color: var(--vn-muted);
  cursor: pointer;
  font-size: 0.82rem;
}
.view-notes-container .mh-item .mh-view:hover {
  color: var(--vn-accent);
}
.view-notes-container .mh-item .mh-desc {
  font-size: 0.74rem;
  color: var(--vn-muted);
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.view-notes-container .mh-item .mh-flag {
  display: inline-block;
  margin-top: 3px;
  font-size: 0.6rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  border-radius: 4px;
  padding: 1px 5px;
  /* amber: real un-scanned order */
  /* grey: billing/charge line item */
}
.view-notes-container .mh-item .mh-flag.pending {
  color: #854f0b;
  background: #faeeda;
}
.view-notes-container .mh-item .mh-flag.billing {
  color: #5f5e5a;
  background: #f1efe8;
}
.view-notes-container .mh-item.billing {
  background: #fafafa;
}
.view-notes-container .mh-item.billing .mh-date {
  color: var(--vn-muted);
  font-weight: 600;
}
.view-notes-container .mh-item.selected {
  background: var(--vn-accent-soft);
  border-left-color: var(--vn-accent);
}
.view-notes-container .mh-item.selected .mh-date {
  color: #134e4a;
}
.view-notes-container .mh-item.selected .mh-desc {
  color: #0f766e;
}
.view-notes-container .notes-date {
  font-size: 0.66rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #94a3b8;
  padding: 2px 2px 4px;
}
.view-notes-container .notes-list-item {
  border: 1px solid var(--vn-border);
  border-radius: 6px;
  margin-bottom: 5px;
  background: #fff;
  cursor: pointer;
  padding: 5px 8px;
  transition: background 0.12s ease, border-color 0.12s ease;
}
.view-notes-container .notes-list-item:hover {
  background: #f6f8fa;
}
.view-notes-container .notes-list-item .nl-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
}
.view-notes-container .notes-list-item .nl-info {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}
.view-notes-container .notes-list-item .nl-type {
  font-size: 0.6rem;
  font-weight: 700;
  text-transform: uppercase;
  color: var(--vn-accent);
  background: var(--vn-accent-soft);
  border-radius: 4px;
  padding: 1px 5px;
  flex-shrink: 0;
}
.view-notes-container .notes-list-item .nl-name {
  font-size: 0.76rem;
  color: var(--vn-strong);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.view-notes-container .notes-list-item .nl-time {
  font-size: 0.68rem;
  color: var(--vn-muted);
  flex-shrink: 0;
}
.view-notes-container .notes-list-item.selected {
  background: var(--vn-accent-soft);
  border-color: var(--vn-accent);
}
.view-notes-container .notes-list-item.selected .nl-name {
  color: #134e4a;
}
.view-notes-container .action-icon-button {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
}
.view-notes-container .notes-detail {
  font-size: 0.85rem;
  color: var(--vn-strong);
  white-space: pre-wrap;
}
.view-notes-container .his-notes-placeholder {
  height: 392px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  border: 1px dashed #cbd5e1;
  border-radius: 8px;
  color: #94a3b8;
}
.view-notes-container .his-notes-placeholder .his-notes-placeholder-title {
  font-size: 1.05rem;
  font-weight: 700;
  margin-bottom: 6px;
  color: #64748b;
}
.view-notes-container .his-notes-placeholder .his-notes-placeholder-text {
  max-width: 420px;
  font-size: 0.86rem;
}

/* Options dropdown (edit / delete) kept compact */
.view-notes-options-menu .ant-dropdown-menu {
  padding-top: 2px;
  padding-bottom: 2px;
}
.view-notes-options-menu .ant-dropdown-menu-item,
.view-notes-options-menu .ant-dropdown-menu-submenu-title {
  min-height: 24px;
  padding-top: 2px;
  padding-bottom: 2px;
  line-height: 18px;
}
.view-notes-options-menu .ant-dropdown-menu-item-group-title {
  padding-top: 2px;
  padding-bottom: 0;
  line-height: 16px;
}
.view-notes-options-menu .ant-dropdown-menu-item-group-list {
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./pages/ManageNodes/view-notes.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,0EAAA;AACA;EACE,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA,EAAA,aAAA;EACA,yBAAA,EAAA,aAAA;EACA,qBAAA;EACA,eAAA;EASA,gCAAA;EAIA,uEAAA;EAmCA,uEAAA;EAiFA,uEAAA;EA+FA,0CAAA;EAcA,uEAAA;EA0EA,uEAAA;EAOA,uEAAA;AArTF;AARE;EACE,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;AAUJ;AANE;EAAgB,kBAAA;AASlB;AARE;EAAgB,iBAAA;AAWlB;AARE;EACE,aAAA;EACA,gDAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,6DAAA;EACA,kCAAA;EACA,kBAAA;AAUJ;AAPE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;AASJ;AANE;EACE,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,sBAAA;AAQJ;AALE;EACE,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAOJ;AAHE;EAAc,gBAAA;AAMhB;AAJE;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,kCAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAMJ;AAHE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,iBAAA;EACA,6BAAA;EACA,yCAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;AAKJ;AAFE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAIJ;AADE;EACE,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,4BAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;AAGJ;AAAE;EACE,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kCAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AAEJ;AAAI;EAAU,mBAAA;AAGd;AADI;EACE,uBAAA;EACA,8BAAA;EACA,iCAAA;AAGN;AACE;EACE,OAAA;EACA,gBAAA;EACA,YAAA;AACJ;AACI;EAAuB,UAAA;AAE3B;AADI;EAA6B,yBAAA;EAA2B,kBAAA;AAK5D;AAFE;EACE,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;AAIJ;AAAE;EACE,kCAAA;EACA,kCAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,0DAAA;AAEJ;AAAI;EAAU,mBAAA;AAGd;AADI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;AAGN;AAAI;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAEN;AACI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AACN;AAEI;EACE,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;AAAN;AAGI;EACE,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AADN;AAII;EAAiB,sBAAA;EAAwB,gBAAA;AAA7C;AAEI;EACE,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;AAAN;AAEM;EAAU,uBAAA;AAChB;AAEI;EACE,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAAN;AAGI;EACE,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EAEqD,iCAAA;EACA,mCAAA;AAF3D;AACM;EAAY,cAAA;EAAgB,mBAAA;AAGlC;AAFM;EAAY,cAAA;EAAgB,mBAAA;AAMlC;AADE;EACE,mBAAA;AAGJ;AAFI;EAAW,sBAAA;EAAwB,gBAAA;AAMvC;AAHE;EACE,iCAAA;EACA,mCAAA;AAKJ;AAHI;EAAW,cAAA;AAMf;AALI;EAAW,cAAA;AAQf;AAJE;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,oBAAA;AAMJ;AAHE;EACE,kCAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,0DAAA;AAKJ;AAHI;EAAU,mBAAA;AAMd;AAJI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;AAMN;AAHI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;AAKN;AAFI;EACE,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,uBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAIN;AADI;EACE,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAGN;AAAI;EACE,kBAAA;EACA,sBAAA;EACA,cAAA;AAEN;AAEE;EACE,iCAAA;EACA,8BAAA;AAAJ;AAEI;EAAW,cAAA;AACf;AAEE;EACE,oBAAA;EACA,mBAAA;EACA,cAAA;AAAJ;AAIE;EACE,kBAAA;EACA,uBAAA;EACA,qBAAA;AAFJ;AAME;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,0BAAA;EACA,kBAAA;EACA,cAAA;AAJJ;AAMI;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AAJN;AAOI;EACE,gBAAA;EACA,kBAAA;AALN;;AAUA,kDAAA;AAEE;EAAqB,gBAAA;EAAkB,mBAAA;AANzC;AAQE;;EAEE,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AANJ;AASE;EACE,gBAAA;EACA,iBAAA;EACA,iBAAA;AAPJ;AAUE;EAAqC,SAAA;AAPvC","sourcesContent":["/* ── View Notes / Medical Notes modal ───────────────────────────────── */\r\n.view-notes-container {\r\n  min-height: 460px;\r\n  --vn-border: #e3e6eb;\r\n  --vn-muted: #6b7280;\r\n  --vn-strong: #1f2937;\r\n  --vn-accent: #0f766e;        /* teal-700 */\r\n  --vn-accent-soft: #ccfbf1;   /* teal-100 */\r\n  --vn-head-bg: #f3f5f8;\r\n  font-size: 13px;\r\n\r\n  .notes-header {\r\n    font-size: 0.95rem;\r\n    font-weight: 700;\r\n    letter-spacing: 0.04em;\r\n    color: #334155;\r\n  }\r\n\r\n  /* Keep the antd tab bar tight */\r\n  .ant-tabs-nav { margin-bottom: 8px; }\r\n  .ant-tabs-tab { padding: 6px 10px; }\r\n\r\n  /* ── Patient card ────────────────────────────────────────────────── */\r\n  .patient-card {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, minmax(0, 1fr));\r\n    column-gap: 18px;\r\n    row-gap: 4px;\r\n    padding: 8px 12px;\r\n    background: linear-gradient(180deg, #fbfcfe 0%, #f5f7fa 100%);\r\n    border: 1px solid var(--vn-border);\r\n    border-radius: 8px;\r\n  }\r\n\r\n  .pc-field {\r\n    display: flex;\r\n    flex-direction: column;\r\n    min-width: 0;\r\n    line-height: 1.25;\r\n  }\r\n\r\n  .pc-label {\r\n    font-size: 0.68rem;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.03em;\r\n    color: var(--vn-muted);\r\n  }\r\n\r\n  .pc-value {\r\n    font-size: 0.82rem;\r\n    font-weight: 600;\r\n    color: var(--vn-strong);\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n  }\r\n\r\n  /* ── Shared column panel ─────────────────────────────────────────── */\r\n  .vn-columns { margin-top: 10px; }\r\n\r\n  .vn-panel {\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: 392px;\r\n    border: 1px solid var(--vn-border);\r\n    border-radius: 8px;\r\n    overflow: hidden;\r\n    background: #fff;\r\n  }\r\n\r\n  .vn-panel-head {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    gap: 6px;\r\n    padding: 6px 10px;\r\n    background: var(--vn-head-bg);\r\n    border-bottom: 1px solid var(--vn-border);\r\n    font-size: 0.74rem;\r\n    font-weight: 700;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.04em;\r\n    color: #475569;\r\n  }\r\n\r\n  .vn-head-right {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n  }\r\n\r\n  .vn-count {\r\n    font-size: 0.66rem;\r\n    font-weight: 700;\r\n    color: #fff;\r\n    background: var(--vn-accent);\r\n    border-radius: 10px;\r\n    padding: 0 6px;\r\n    line-height: 16px;\r\n  }\r\n\r\n  .mh-toggle {\r\n    font-size: 0.64rem;\r\n    font-weight: 600;\r\n    text-transform: none;\r\n    letter-spacing: 0;\r\n    color: var(--vn-muted);\r\n    border: 1px solid var(--vn-border);\r\n    border-radius: 10px;\r\n    padding: 1px 8px;\r\n    cursor: pointer;\r\n\r\n    &:hover { background: #eef0f3; }\r\n\r\n    &.active {\r\n      color: var(--vn-accent);\r\n      border-color: var(--vn-accent);\r\n      background: var(--vn-accent-soft);\r\n    }\r\n  }\r\n\r\n  .vn-panel-body {\r\n    flex: 1;\r\n    overflow-y: auto;\r\n    padding: 6px;\r\n\r\n    &::-webkit-scrollbar { width: 6px; }\r\n    &::-webkit-scrollbar-thumb { background-color: #d1d5db; border-radius: 4px; }\r\n  }\r\n\r\n  .vn-empty {\r\n    color: #9aa1ab;\r\n    font-style: italic;\r\n    font-size: 0.8rem;\r\n    padding: 8px;\r\n    text-align: center;\r\n  }\r\n\r\n  /* ── Medical history items ───────────────────────────────────────── */\r\n  .mh-item {\r\n    border: 1px solid var(--vn-border);\r\n    border-left: 3px solid transparent;\r\n    border-radius: 6px;\r\n    padding: 5px 8px;\r\n    margin-bottom: 5px;\r\n    cursor: pointer;\r\n    transition: background 0.12s ease, border-color 0.12s ease;\r\n\r\n    &:hover { background: #f6f8fa; }\r\n\r\n    .mh-top {\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: space-between;\r\n      gap: 6px;\r\n    }\r\n\r\n    .mh-date {\r\n      font-size: 0.74rem;\r\n      font-weight: 700;\r\n      color: #374151;\r\n      white-space: nowrap;\r\n      overflow: hidden;\r\n      text-overflow: ellipsis;\r\n    }\r\n\r\n    .mh-chips {\r\n      display: flex;\r\n      align-items: center;\r\n      gap: 4px;\r\n      flex-shrink: 0;\r\n    }\r\n\r\n    .mh-mod {\r\n      font-size: 0.62rem;\r\n      font-weight: 700;\r\n      color: var(--vn-accent);\r\n      background: var(--vn-accent-soft);\r\n      border-radius: 4px;\r\n      padding: 1px 5px;\r\n      letter-spacing: 0.02em;\r\n    }\r\n\r\n    .mh-nc {\r\n      font-size: 0.62rem;\r\n      font-weight: 700;\r\n      color: #fff;\r\n      background: #8b5cf6;\r\n      border-radius: 9px;\r\n      min-width: 16px;\r\n      height: 16px;\r\n      display: inline-flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      padding: 0 4px;\r\n    }\r\n\r\n    .mh-reportdate { color: var(--vn-muted); font-weight: 600; }\r\n\r\n    .mh-view {\r\n      display: inline-flex;\r\n      align-items: center;\r\n      color: var(--vn-muted);\r\n      cursor: pointer;\r\n      font-size: 0.82rem;\r\n\r\n      &:hover { color: var(--vn-accent); }\r\n    }\r\n\r\n    .mh-desc {\r\n      font-size: 0.74rem;\r\n      color: var(--vn-muted);\r\n      margin-top: 2px;\r\n      white-space: nowrap;\r\n      overflow: hidden;\r\n      text-overflow: ellipsis;\r\n    }\r\n\r\n    .mh-flag {\r\n      display: inline-block;\r\n      margin-top: 3px;\r\n      font-size: 0.6rem;\r\n      font-weight: 700;\r\n      text-transform: uppercase;\r\n      letter-spacing: 0.02em;\r\n      border-radius: 4px;\r\n      padding: 1px 5px;\r\n\r\n      &.pending { color: #854f0b; background: #faeeda; }   /* amber: real un-scanned order */\r\n      &.billing { color: #5f5e5a; background: #f1efe8; }   /* grey: billing/charge line item */\r\n    }\r\n  }\r\n\r\n  /* billing/charge rows are de-emphasised */\r\n  .mh-item.billing {\r\n    background: #fafafa;\r\n    .mh-date { color: var(--vn-muted); font-weight: 600; }\r\n  }\r\n\r\n  .mh-item.selected {\r\n    background: var(--vn-accent-soft);\r\n    border-left-color: var(--vn-accent);\r\n\r\n    .mh-date { color: #134e4a; }\r\n    .mh-desc { color: #0f766e; }\r\n  }\r\n\r\n  /* ── Order notes list ────────────────────────────────────────────── */\r\n  .notes-date {\r\n    font-size: 0.66rem;\r\n    font-weight: 700;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.03em;\r\n    color: #94a3b8;\r\n    padding: 2px 2px 4px;\r\n  }\r\n\r\n  .notes-list-item {\r\n    border: 1px solid var(--vn-border);\r\n    border-radius: 6px;\r\n    margin-bottom: 5px;\r\n    background: #fff;\r\n    cursor: pointer;\r\n    padding: 5px 8px;\r\n    transition: background 0.12s ease, border-color 0.12s ease;\r\n\r\n    &:hover { background: #f6f8fa; }\r\n\r\n    .nl-row {\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: space-between;\r\n      gap: 6px;\r\n    }\r\n\r\n    .nl-info {\r\n      display: flex;\r\n      align-items: center;\r\n      gap: 6px;\r\n      min-width: 0;\r\n    }\r\n\r\n    .nl-type {\r\n      font-size: 0.6rem;\r\n      font-weight: 700;\r\n      text-transform: uppercase;\r\n      color: var(--vn-accent);\r\n      background: var(--vn-accent-soft);\r\n      border-radius: 4px;\r\n      padding: 1px 5px;\r\n      flex-shrink: 0;\r\n    }\r\n\r\n    .nl-name {\r\n      font-size: 0.76rem;\r\n      color: var(--vn-strong);\r\n      white-space: nowrap;\r\n      overflow: hidden;\r\n      text-overflow: ellipsis;\r\n    }\r\n\r\n    .nl-time {\r\n      font-size: 0.68rem;\r\n      color: var(--vn-muted);\r\n      flex-shrink: 0;\r\n    }\r\n  }\r\n\r\n  .notes-list-item.selected {\r\n    background: var(--vn-accent-soft);\r\n    border-color: var(--vn-accent);\r\n\r\n    .nl-name { color: #134e4a; }\r\n  }\r\n\r\n  .action-icon-button {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    flex-shrink: 0;\r\n  }\r\n\r\n  /* ── Note / document preview ─────────────────────────────────────── */\r\n  .notes-detail {\r\n    font-size: 0.85rem;\r\n    color: var(--vn-strong);\r\n    white-space: pre-wrap;\r\n  }\r\n\r\n  /* ── HIS placeholder ─────────────────────────────────────────────── */\r\n  .his-notes-placeholder {\r\n    height: 392px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    text-align: center;\r\n    border: 1px dashed #cbd5e1;\r\n    border-radius: 8px;\r\n    color: #94a3b8;\r\n\r\n    .his-notes-placeholder-title {\r\n      font-size: 1.05rem;\r\n      font-weight: 700;\r\n      margin-bottom: 6px;\r\n      color: #64748b;\r\n    }\r\n\r\n    .his-notes-placeholder-text {\r\n      max-width: 420px;\r\n      font-size: 0.86rem;\r\n    }\r\n  }\r\n}\r\n\r\n/* Options dropdown (edit / delete) kept compact */\r\n.view-notes-options-menu {\r\n  .ant-dropdown-menu { padding-top: 2px; padding-bottom: 2px; }\r\n\r\n  .ant-dropdown-menu-item,\r\n  .ant-dropdown-menu-submenu-title {\r\n    min-height: 24px;\r\n    padding-top: 2px;\r\n    padding-bottom: 2px;\r\n    line-height: 18px;\r\n  }\r\n\r\n  .ant-dropdown-menu-item-group-title {\r\n    padding-top: 2px;\r\n    padding-bottom: 0;\r\n    line-height: 16px;\r\n  }\r\n\r\n  .ant-dropdown-menu-item-group-list { margin: 0; }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
